import ReactDOM from 'react-dom';
import React from 'react';
import Config from '../etc/Config.jsx';
import classnames from 'classnames';
import {ResizableBox} from 'react-resizable';
import GithubGate from './GithubGate.jsx';
import Card from './Card.jsx';
import Error from './Error.jsx';

class App extends React.Component {
    constructor(props){
        super(props);

        this.state = {
            ready: false,
            keyword: '',
            searchResults: [],
            cards: [],
            searching: false,
            repos: {},
            currentRepo: null,
            user: {
                'avatar': '',
                'name': ''
            },
            error: null
        }
        this.conf = new Config();
        this.gate = new GithubGate(this.conf);
        this.getURLParams = this.getURLParams.bind(this);
        this.search = this.search.bind(this);
        this.open = this.open.bind(this);
        this.addCard = this.addCard.bind(this);
        this.raiseError = this.raiseError.bind(this);
        this.returnToStart = this.returnToStart.bind(this);
        this.dismissError = this.dismissError.bind(this);
        this.handleRepoChange = this.handleRepoChange.bind(this);
        this.handleKeywordChange = this.handleKeywordChange.bind(this);
        this.handleKeywordKeyPress = this.handleKeywordKeyPress.bind(this);
        this.acceptCard = this.acceptCard.bind(this);
        this.updateCardChangeStatus = this.updateCardChangeStatus.bind(this);
    }

    componentDidMount(){
        var self = this;
        var params = this.getURLParams();

        if(params.code && params.state){
            this.gate.getAccessToken(
                params.code, 
                params.state,
                ()=>{
                    this.gate.getUser(
                        (user) => {
                            this.returnToStart();
                        },
                        (error) => {
                            self.raiseError(
                                <Error 
                                    text={'Не удалось получить ваш профиль из Github. Ошибка: '+error}
                                    onDismiss={this.returnToStart}
                                />
                            );
                        }
                    )
                },
                (error) => {
                    self.raiseError(
                        <Error 
                            text={'Не удалось авторизоваться через Github. Ошибка: '+error}
                            onDismiss={this.returnToStart}
                        />
                    );
                }
            );
        }
        else if(params.error){
            self.raiseError(
                <Error 
                    text={'При попытке авторизовать вас через Github произошла вот такая ошибка: '+params.error+' '+params.error_description}
                    onDismiss={this.returnToStart}
                />
            );
        }
        else{
            this.gate.checkAuthorization(
                (user) => {
                    var repos = {};
                    var hasRepos = false;
                    Object.keys(this.conf.corpuses)
                        .filter(code=>!this.conf.corpuses[code].disabled)
                        .map(code => {
                            if(user.repos[this.conf.corpuses[code].repo]){
                                repos[code] = this.conf.corpuses[code];
                                repos[code].code = code;
                                repos[code].canWriteMaster = user.repos[this.conf.corpuses[code].repo].canWriteMaster;
                                hasRepos = true;
                            }
                        });
                    if(!hasRepos){
                        self.raiseError(
                            <Error 
                                text={'У вас нет ни одного словарного репозитория.'}
                                dismissable={false}
                            />
                        );
                        return;
                    }
                    this.setState({
                        user: {
                            name: user.name,
                            avatar: user.avatar
                        },
                        repos: repos,
                        currentRepo: repos[Object.keys(repos)[0]],
                        ready: true
                    });
                },
                () => {
                    this.gate.getOauthCode();
                }
            );
        }
    }

    raiseError(error){
        this.setState({error: error});
    }

    dismissError(){
        this.setState({
            error: null
        });
    }

    returnToStart(){
        window.location = window.location.protocol+'//'+window.location.host+window.location.pathname;
    }

    search(){
        if(!this.state.keyword) return;

        this.setState({searching: true});
        this.gate.search(
            this.state.currentRepo.code,
            this.state.keyword,
            (results)=>{
                this.setState({searchResults: results});
                this.setState({searching: false});
            },
            ()=>{
                this.setState({searchResults: []});
                this.setState({searching: false});
            }
        );
    }

    open(card){
        var opened = false;
        this.state.cards.map(c => {
            if(c.code == card.code && c.corpus == card.corpus){
                c.active = true;
                opened = true;
            }
            else{
                c.active = false;
            }
        });
        if(!opened){
            var title = card.header.replace(/<[^\>]+>/g,'');
            var _t = card.header.substring(0, card.header.indexOf('('));
            if(_t){
                title = _t;
            }
            var nCard = {
                code: card.code,
                corpus: card.corpus,
                active: true,
                changed: false,
                title: title
            }            
            this.state.cards.push(nCard);
        }
        this.setState({cards: this.state.cards});
    }

    close(card){
        if(card.changed){
            if(!confirm('Изменения в карточке не сохранены. Вы уверены, что хотите ее закрыть?')){
                return;
            }
        }
        var cardsLeft = [];
        for(var i=0; i < this.state.cards.length; i++){
            var c = this.state.cards[i];
            if(c.code == card.code && c.corpus == card.corpus){
                if(card.active){
                    if(i > 0){
                        cardsLeft[i-1].active = true;
                    }
                    else if(this.state.cards[i+1]){
                        this.state.cards[i+1].active = true;
                    }
                }
            }
            else{
                cardsLeft.push(c);
            }
        }
        this.setState({cards: cardsLeft})
    }

    handleRepoChange(e){
        this.setState({currentRepo: this.state.repos[e.currentTarget.value]});
    }

    handleKeywordChange(e){
        this.setState({keyword: e.currentTarget.value});
    }

    handleKeywordKeyPress(event){
        if(event.charCode == 13){
            event.preventDefault();
            this.search();
        }
    }    

    getURLParams(){
        var match,
            pl     = /\+/g,
            search = /([^&=]+)=?([^&]*)/g,
            decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
            query  = window.location.search.substring(1);

        var urlParams = {};
        while (match = search.exec(query)){
            urlParams[decode(match[1])] = decode(match[2]);
        }
        return urlParams;
    }

    addCard(){
        var newCard = {
            corpus: this.state.currentRepo.code,
            code: 'new-'+Math.random(),
            header: '...【...】(...)〔код будет присвоен автоматически〕',
            isNew: true,
            title: 'новая'
        }
        this.state.cards.push(newCard);
        this.setState(this.state);
        this.open(newCard);
    }

    acceptCard(corpus, code, newCode, newHeader){
        this.state.cards.map(c => {
            if(c.code == code && c.corpus == corpus){
                var title = newHeader.replace(/<[^\>]+>/g,'');
                var _t = newHeader.substring(0, newHeader.indexOf('('));
                if(_t){
                    title = _t;
                }
                c.isNew = false;
                c.changed = false;
                c.code = newCode;
                c.header = newHeader;
                c.title = title;
            }
        });
        this.setState(this.state);
    }

    updateCardChangeStatus(corpus, code, changed){
        this.state.cards.map(c => {
            if(c.code == code && c.corpus == corpus && c.changed != changed){
                c.changed = changed;
            }
        });
        this.setState(this.state);
    }

    render(){
        
        if(!this.state.ready){
            if(this.state.error){
                return this.state.error;
            }
            return <div className="loading"><h1><i className="fas fa-circle-notch fa-spin"></i></h1></div>;
        }

        var activeTab = this.state.cards.find(c=>c.active) || '';
        return (
            <React.Fragment>
                <div id="header">
                    <div className="product-name">Редактор WARODAI</div>
                    <div className="main-panel"></div>
                    <div className="user">
                        <span>{this.state.user.name}</span>
                        <div 
                            className="avatar" 
                            style={{'backgroundImage':'url('+this.state.user.avatar+')'}}
                        ></div>
                    </div>
                </div>
                <div id="workpane" className="flex-grow-1 d-flex">
                    <ResizableBox id="search-panel" className="d-flex flex-column flex-shrink-0" axis="x" width={300} resizeHandles={['e']}>
                        <div id="search-form" className="p-2">
                            {Object.keys(this.state.repos).length > 1 && (
                                <div className="input-group mb-2">
                                    <div className="input-group-prepend">
                                        <div className="input-group-text">Репозиторий:</div>
                                    </div>
                                    <select className="custom-select" value={this.state.currentRepo.code} onChange={this.handleRepoChange}>
                                        {Object.keys(this.state.repos).map(code => (
                                            <option key={code} value={code}>
                                                {this.state.repos[code].name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            )}
                            <div className="input-group">
                                <input 
                                    type="text" 
                                    className="form-control" 
                                    onChange={this.handleKeywordChange}
                                    value={this.state.keyword}
                                    onKeyPress={this.handleKeywordKeyPress}
                                    placeholder="Ключевое слово или код карточки"
                                />
                                <div className="input-group-append">
                                    <button className="btn btn-outline-secondary" type="button" onClick={this.search}>
                                        {this.state.searching ? (
                                            <span className="fas fa-circle-notch fa-spin" />
                                        ) : (
                                            <span className="fa fa-search"></span>
                                        )}                                        
                                    </button>
                                </div>
                            </div>
                        </div>

                        <ul id="entries" className="flex-grow-1 mb-0 px-2">
                            {this.state.searchResults.map(card => (
                                <li className="entry mx-0 my-2 p-1"　key={card.corpus+card.code}　onClick={()=>this.open(card)}>                                   
                                   {Object.keys(this.state.repos).length > 1 && (
                                        <span 
                                            className="badge mr-1" 
                                            style={{
                                                'backgroundColor': this.state.repos[card.corpus].color,
                                                'color': this.state.repos[card.corpus].fontColor
                                            }} 
                                            title={card.corpus}
                                        >
                                            {card.corpus[0]}
                                        </span> 
                                    )}                                    
                                   {card.header}
                                </li>
                            ))}
                        </ul>
                    </ResizableBox>
                    <div id="edit-panel" className="ml-1 flex-grow-1 d-flex flex-column">
                        <ul className="primary-tabs nav nav-tabs mt-2">
                            {this.state.cards.map(card => (
                                <li className="nav-item" key={card.corpus+card.code}>                                    
                                    <a className={classnames({'nav-link':true, 'active':card.active})}　onClick={()=>this.open(card)} title={card.header}>
                                        {(card.changed) && <span className="changed">• </span>}
                                        {card.title}<br/>
                                        <small>
                                            {Object.keys(this.state.repos).length > 1 && (
                                                <span 
                                                    className="badge mr-1" 
                                                    style={{
                                                        'backgroundColor': this.state.repos[card.corpus].color,
                                                        'color': this.state.repos[card.corpus].fontColor
                                                    }} 
                                                    title={card.corpus}
                                                >
                                                    {card.corpus[0]}
                                                </span> 
                                            )} 
                                            {card.isNew ? '00000-00' : card.code}
                                        </small>
                                    </a>
                                    <span className="fa fa-times close" onClick={()=>{this.close(card)}}></span>
                                </li>
                            ))}
                            {this.state.currentRepo.canAddCards && (
                                <li className="nav-item">
                                    <a className="nav-link" id="add-card-tab" onClick={this.addCard} title="новая карточка">
                                        <i className="fas fa-plus"></i>
                                    </a>
                                </li>
                            )}
                        </ul>
                        <div className="flex-grow-1 d-flex flex-column">
                        {this.state.cards.map(card => (                            
                            <div
                                className={classnames({'d-flex':card.active, 'd-none':!card.active, 'flex-column':true, 'flex-grow-1':true})} 
                                key={card.corpus+card.code}
                            >
                                <Card
                                    canWriteMaster={this.state.repos[card.corpus].canWriteMaster}
                                    code={card.code}
                                    corpus={card.corpus}
                                    header={card.header}
                                    isNew={card.isNew}
                                    gate={this.gate}
                                    conf={this.conf}
                                    acceptCard={this.acceptCard}
                                    updateCardChangeStatus={this.updateCardChangeStatus}
                                    raiseError={this.raiseError}
                                    dismissError={this.dismissError}
                                />
                            </div>
                        ))}
                        </div>
                    </div>
                </div>

                {this.state.error && this.state.error}
            </React.Fragment>
        );
    }
}

ReactDOM.render(
    <App />, 
    document.getElementById('root')
)